import errorCatchersStorage from '../helpers/error-catchers-storage';

function catchError(...args) {
  errorCatchersStorage.forEach((catcher) => catcher(...args));
}

export default catchError;
